module.exports = __webpack_public_path__ + "img/illustrations-error.6040797b.svg";